

import {
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { EntrataDiMagazzino } from "src/app/models/entrataDiMagazzino.model";
import { MandatoDiPagamento } from "src/app/models/mandatoDiPagamento.model";
import { EntrateDiMangazzinoService } from "src/app/services/entrateDiMagazzino.service";

import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";


@Component({
  templateUrl: "./dialog-registra-em.component.html",
  styleUrls: ["../bef.component.css"],
})
export class RegistraEmComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  
  protected isLoadingRegistraEM:Boolean = false;
  protected mdp:MandatoDiPagamento;
  public registraEmForm: FormGroup;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public stiliService:StiliService,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private emService:EntrateDiMangazzinoService,
    private messageService: MessageService,

  ) {
    this.mdp  = this.config.data.mdp;
    this.registraEmForm = this.formBuilder.group({
      codice:         new FormControl({value: null, disabled: false}, Validators.required),
      valore:         new FormControl({value: this.mdp.valore, disabled: false}, Validators.required),
      dataEmissione:  new FormControl({value: new Date(), disabled: false}, Validators.required),
    });
  }

  ngOnInit(): void {
    
   

  }


  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let nuovaEntrataDiMagazzino:EntrataDiMagazzino = new EntrataDiMagazzino();
          nuovaEntrataDiMagazzino.mandatoDiPagamento = this.mdp;
          nuovaEntrataDiMagazzino.valore             = this.registraEmForm.value.valore;
          nuovaEntrataDiMagazzino.codice              = this.registraEmForm.value.codice;
          nuovaEntrataDiMagazzino.dataEmissione       = this.registraEmForm.value.dataEmissione;
          this.emService.crea(nuovaEntrataDiMagazzino).subscribe( {
            next: (resCreaEm) => {
              this.isLoadingRegistraEM = false;
              this.dialogRef.close({ success: true });
            },
            error: (e) => {
                this.isLoadingRegistraEM = false;
                this.logger.error(e);
                this.dialogRef.close({ success: false });
                this.messageService.add({
                  severity: "error",
                  summary: "ATTENZIONE",
                  detail: "Errore in fase di registrazione dell'entrata di magazzino!", life:10000
                });
            },
            complete: () => {

            }
        });  
          
    }
  }
}
